import { ProfileEdit } from '../Components/Common/ProfileEdit'
import { ChangePassword } from '../Components/Common/ChangePassword'
import { StudentProfile } from '../Components/Common/StudentProfile'
import { InstructorStudentTaskList } from '../Components/StudentManagement'
import { StudentScheduleList } from '../Components/ScheduleManagement'
import { StudentCurriculumTable } from '../Components/CurriculumManagement'
import { StudentCollegeList } from '../Components/CollegeManagement'
import { StudentAdditionalInfo } from '../Components/AdditionalInfo'
import { StudentDeadlines } from '../Components/Deadlines'
import { StudentFinancialAid } from '../Components/FinancialAid'
import { StudentMainEssay } from '../Components/MainEssay'
import { StudentSupplementalEssay } from '../Components/SupplementalEssay'
import { StudentBragSheet } from '../Components/BragSheet'
import { StudentActivitiesAwards, StudentActivityEdit, StudentAwardEdit } from '../Components/ActivitiesAwards'

export const student12Routes = [
	// Profile Routes
	{ path: `${process.env.PUBLIC_URL}/student12/profile/:layout`, Component: <StudentProfile /> },
	{ path: `${process.env.PUBLIC_URL}/student12/profile-edit/:layout`, Component: <ProfileEdit /> },
	{ path: `${process.env.PUBLIC_URL}/student12/change-password/:layout`, Component: <ChangePassword /> },

	// Student 12 specific routes
	{ path: `${process.env.PUBLIC_URL}/student12/agenda/:layout`, Component: <InstructorStudentTaskList /> },
	{ path: `${process.env.PUBLIC_URL}/student12/schedule/:layout`, Component: <StudentScheduleList /> },
	{ path: `${process.env.PUBLIC_URL}/student12/timeline/:layout`, Component: <StudentCurriculumTable /> },
	{ path: `${process.env.PUBLIC_URL}/student12/college-list/:layout`, Component: <StudentCollegeList /> },
	{ path: `${process.env.PUBLIC_URL}/student12/deadlines/:layout`, Component: <StudentDeadlines /> },
	{ path: `${process.env.PUBLIC_URL}/student12/fin-aid/:layout`, Component: <StudentFinancialAid /> },
	{ path: `${process.env.PUBLIC_URL}/student12/main-essay/:layout`, Component: <StudentMainEssay /> },
	{ path: `${process.env.PUBLIC_URL}/student12/supplemental-essay/:layout`, Component: <StudentSupplementalEssay /> },
	{ path: `${process.env.PUBLIC_URL}/student12/additional-info/:layout`, Component: <StudentAdditionalInfo /> },
	{ path: `${process.env.PUBLIC_URL}/student12/brag-sheet/:layout`, Component: <StudentBragSheet /> },
	{ path: `${process.env.PUBLIC_URL}/student12/activities-awards/:layout`, Component: <StudentActivitiesAwards /> },
	{ path: `${process.env.PUBLIC_URL}/student12/activity-edit/:status/:id/:layout`, Component: <StudentActivityEdit /> },
	{ path: `${process.env.PUBLIC_URL}/student12/award-edit/:status/:id/:layout`, Component: <StudentAwardEdit /> }
]
